import './LtvAnalysis.scss';
import Row from 'react-bootstrap/Row';
import { Spin } from 'antd';
import { useEffect, useRef, useState } from 'react';
import LtvFilterCard from './LtvFilterCard';
import LtvTableCard from './LtvTableCard';
import LtvAnalysisServices from 'services/services/LtvAnalysisServices';
import Cookies from 'universal-cookie';
import ExtLtvFilterCard from './ExtLtvFilterCard';
import ExtLtvTableCard from './ExtLtvTableCard';

const initialState = { start_buildyear: "", end_buildyear: "", property_type: [], ownership_type: [], sale_months: "" }

const LtvAnalysis = (props: any) => {
    const cookies = new Cookies();
    const [loading, setLoading] = useState<boolean>(false);
    const [ltvDetails, setLtvDetails] = useState<any>({});
    const [searchData, setSearchData] = useState<any>(initialState);
    const cardTargetRef: any = useRef();
    const [cardDimensions, setCardDimensions] = useState({ height: 0 });

    

    useEffect(() => {
        initialRenderData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initialRenderData = () => {
        let object: any = {};
        object.customer_id = props?.id;
        setLoading(true);
        
        // let ltvAnalysis = sessionStorage.getItem("ltvAnalysis-"+props?.id);
        let ltvAnalysis = cookies.get("ltvAnalysis-"+props?.id);

        if(ltvAnalysis){
            let ltvAnalysis2:any = ltvAnalysis;//JSON.parse(ltvAnalysis);
            if(typeof ltvAnalysis2 === 'object'){
                object = { ...object, ...ltvAnalysis2}
            }
        }

        LtvAnalysisServices
        .getLtvData(object)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                const responseData = response?.data?.data;
                let propertyType = responseData?.customer_data?.filter_property_type !== "" ? responseData?.customer_data?.filter_property_type.split(',') : [];
                let ownershipType = responseData?.customer_data?.filter_ownership_type !== "" ? responseData?.customer_data?.filter_ownership_type.split(',') : [];
                setLtvDetails(responseData)
                setSearchData({ ...searchData, 
                    start_buildyear: responseData?.customer_data?.start_buildyear, 
                    end_buildyear: responseData?.customer_data?.end_buildyear, 
                    property_type: propertyType, 
                    ownership_type: ownershipType, 
                    sale_months: responseData?.customer_data?.sale_months 
                });
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    }

    const handleSubmit = (e: any) => {
        let object: any = e;
        object.customer_id = props?.id;
        // object.property_type = searchData.property_type;
        // object.ownership_type = searchData.ownership_type;
        // object.start_buildyear = searchData.start_buildyear;
        // object.end_buildyear = searchData.end_buildyear;
        // object.sale_months = searchData.sale_months;

        // sessionStorage.setItem("ltvAnalysis-"+props?.id, JSON.stringify(object));
        cookies.set("ltvAnalysis-"+props?.id, object, { path: '/' });

        setSearchData(object)
        setLoading(true);
        LtvAnalysisServices
        .getLtvData(object)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                setLtvDetails(response?.data?.data)
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    }

    const handleReset = (e:any) =>{
        cookies.remove("ltvAnalysis-"+props?.id,  { path: '/' });
        initialRenderData();
    }

    return (
        <>
            <Spin spinning={loading} >
                <div className="site-card-wrapper  mt-3">
                    <Row>
                    { props?.externalCustomer 
                        ? <ExtLtvFilterCard
                            searchData={searchData}
                            handleSubmit={handleSubmit}
                            handleReset={handleReset}
                            cardDimensions={cardDimensions}
                        />
                        : <LtvFilterCard
                            searchData={searchData}
                            handleSubmit={handleSubmit}
                            handleReset={handleReset}
                            cardDimensions={cardDimensions}
                        />
                    }
                    {
                        props?.externalCustomer 
                        ? <ExtLtvTableCard
                            tableData={ltvDetails}
                            cardTargetRef={cardTargetRef}
                            setCardDimensions={setCardDimensions}
                        />
                        : <LtvTableCard
                            tableData={ltvDetails}
                            cardTargetRef={cardTargetRef}
                            setCardDimensions={setCardDimensions}
                        />
                    }
                        
                    </Row>
                </div>
            </Spin>
        </>
    );
};
export default LtvAnalysis;